export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/diary": [3],
		"/diary/bookmarks": [4],
		"/first-launch": [5],
		"/invite/[token]": [6],
		"/login": [7],
		"/my": [8],
		"/my/create-space": [9],
		"/news": [10],
		"/notifications": [11],
		"/onboarding": [12],
		"/photo-calendar": [13],
		"/schedule": [14],
		"/search": [15],
		"/settings": [16],
		"/settings/account": [17],
		"/settings/app-info": [18],
		"/settings/blocked-users": [19],
		"/settings/feedback": [20],
		"/settings/holiday-country": [21],
		"/settings/language": [22],
		"/settings/notices": [23],
		"/settings/notifications": [24],
		"/settings/privacy": [25],
		"/settings/terms": [26],
		"/settings/theme": [27],
		"/settings/timezone": [28],
		"/settings/widget": [29],
		"/spaces": [30],
		"/spaces/[spaceId]": [31],
		"/spaces/[spaceId]/diary": [32],
		"/spaces/[spaceId]/photos": [33],
		"/spaces/[spaceId]/photos/new/post": [34],
		"/spaces/[spaceId]/settings": [35],
		"/spaces/[spaceId]/settings/anniversaries": [36],
		"/spaces/[spaceId]/settings/anniversaries/new": [37],
		"/spaces/[spaceId]/settings/invite": [38],
		"/spaces/[spaceId]/settings/members/[userId]": [39],
		"/subscribe": [40],
		"/terms": [41],
		"/terms/refund": [43],
		"/terms/[type]": [42],
		"/welcome": [44]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';